import Typography from '../Typography';
import Icon from '../Icon';
import { Button, Grid, Stack, styled as muiStyled } from '@mui/material';
import type { LogoutButtonProps } from './types';
import { NEW_COLORS } from '../../themes/colors/newColors';

const Container = muiStyled(Grid)``;

const Username = muiStyled(Typography)(({ theme }) => ({
  color: NEW_COLORS.GRAYSCALE[700],

  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '40ch',

  [theme.breakpoints.down('xl')]: {
    maxWidth: '18ch',
  },

  [theme.breakpoints.down('lg')]: {
    maxWidth: '5ch',
  },

  [theme.breakpoints.down(830)]: {
    display: 'none',
  },
}));

const ChevronDown = muiStyled(Icon)`
  color: ${NEW_COLORS.PRIMARY[500]};
`;

const MobileHiddenStack = muiStyled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down(830)]: {
    display: 'none',
  },
}));

const LogoutButton = muiStyled(Button)<LogoutButtonProps>(
  ({ theme, isBackoffice }) => ({
    fontWeight: 400,
    fontSize: 14,
    color: isBackoffice ? NEW_COLORS.BASE.WHITE : NEW_COLORS.PRIMARY[500],
    '& .MuiButton-startIcon': {
      color: isBackoffice ? NEW_COLORS.SECONDARY[500] : NEW_COLORS.PRIMARY[500],
    },
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingLeft: '8px',
    },
  }),
);

export { LogoutButton, MobileHiddenStack, ChevronDown, Username, Container };
